module.exports = __webpack_public_path__ + "static/media/stbt.ee2b910c.svg";